import HTTP from "../utils/httpClient";
import * as types from "../types/globalParametersType";
import { asyncActionStart, asyncActionFinish } from "./../asyncLoading/AsyncAction";

const config = {
    headers: {
        "Content-Type": "application/json"
    }
};

export const getGlobalParameters = (requestParams) => async (dispatch) => {
    try {
        dispatch(asyncActionStart());
        const res = await HTTP.get(`/api/v1/global/params`, {
            params: {
                ...requestParams
            }
        });
        dispatch({
            type: types.GET_GLOBAL_PARAMETERS,
            payload: res.data.data.content
        });
        dispatch(asyncActionFinish());
    } catch (err) {
        // console.log(err)
        dispatch(asyncActionFinish());
        if (err.response) {
            dispatch({
                type: types.GET_GLOBAL_PARAMETERS_ERROR,
                payload: err.response.data.error
            });
        }
    }
};

export const getGlobalParametersById = (parameterId) => {
    return HTTP.get(`/api/v1/global/params`, {
        params: {
            id: parameterId
        }
    });
};

export const createGlobalParameter = (data) => {
    return HTTP.post(`/api/v1/global/params`, data, config);
};

export const updateGlobalParameter = (parameterId, data) => {
    return HTTP.put(`/api/v1/global/params/${parameterId}`, data, config);
};
